<template>
  <div class="user-list">
    <header style="font-weight: bold;">
      2. ลูกบ้าน
      <span v-if="users.length">({{ numberOfUser }} คน)</span>
    </header>
    <hr />
    <div class="row">
      <el-autocomplete
        class="user-search-input col-6"
        v-model="search"
        :fetch-suggestions="querySearch"
        placeholder="ค้นหาลูกบ้าน"
        :trigger-on-focus="false"
        @select="handleSelect"
        :disabled="canSelectJustOneUser || !transferId"
      >
        <template slot-scope="{ item }">
          <div class="user">
            <div class="name">{{ item.name }}</div>
            <div class="home">{{ item.home }}</div>
            <div class="home">{{ item.role }}</div>
          </div>
        </template>
      </el-autocomplete>
      <el-autocomplete
        class="user-search-input col-6"
        v-model="project"
        :fetch-suggestions="projectQuerySearch"
        placeholder="ค้นหาโครงการ / บ้านเลขที่"
        :trigger-on-focus="false"
        @select="handleSelect"
        :disabled="canSelectJustOneUser || !transferId"
      >
        <template slot-scope="{ item }">
          <div class="user">
            <div class="name">{{ item.name }}</div>
            <div class="home">{{ item.home }}</div>
            <div class="home">{{ item.role }}</div>
          </div>
        </template>
      </el-autocomplete>
    </div>
    <div v-for="(user, index) in users" :key="index" class="user-list-item">
      <div class="user">
        <div class="name">{{ user.name }}</div>
        <div class="home">{{ user.home }}</div>
        <div class="home">{{ user.role }}</div>
      </div>
      <button class="btn-delete" @click="handleClickDeleteUser(user.id, user.homeId)">
        <img src="/static/icons/trash.svg" :alt="$t('label.delete')" />
      </button>
    </div>
  </div>
</template>

<script>
import { Autocomplete } from "element-ui";
import { baanRueJaiClient } from "@/dependencies";
import { toCamelCaseObject } from '@/lib/util';

export default {
  components: {
    ElAutocomplete: Autocomplete
  },
  props: ["value", "canSelectOneUser", "isFilterTokenxUser", "transferId"],
  data() {
    const search = "";
    const project = "";
    return {
      search,
      project
    };
  },
  computed: {
    numberOfUser() {
      return this.value.length;
    },
    users() {
      return this.value;
    },
    canSelectJustOneUser() {
      return this.canSelectOneUser
        && this.value
        && this.value.length === 1
    }
  },
  methods: {
    async querySearch(queryString, cb) {
      let query = {
        text_search: queryString,
        project_home_search: ""
      };

      if (this.isFilterTokenxUser) {
        query = {...query, is_filter_tokenx_user: true }
      }

      const response = await baanRueJaiClient.admin.users.search(query);
      const users = response.data.result.users;

      if (this.isFilterTokenxUser) {
        cb(
          users
            .map(user => toCamelCaseObject(user))
            .filter(user => user.homes && user.homes.length)
            .map(item => {
              const user = item.user;
              const name = `${user.userProfile.firstName} ${
                user.userProfile.lastName
              }`;
              const home = item.homes[0];

              return {
                id: user.userId,
                homeId: home.homeId,
                projectId: home.projectId,
                name,
                home: `${home.addressNo} ${home.projectName}`,
                role: home.role,
                homes: item.homes
              };
            })
        );
      } else {
        cb(
          users
            .map(user => toCamelCaseObject(user))
            .filter(user => user.homes && user.homes.length)
            .flatMap(item => {
              const user = item.user;
              const homes = item.homes;
              const name = `${user.userProfile.firstName} ${
                user.userProfile.lastName
              }`;

              return homes.map(h => {
                const home = `${h.addressNo} ${h.projectName}`;
                const role = h.userRole;
                const projectId = h.projectId;

                return {
                  id: user.userId,
                  homeId: h.homeId,
                  projectId,
                  name,
                  home,
                  role,
                  data: { user: user, home: h }
                };
              });
            })
        );
      }
    },
    async projectQuerySearch(queryString, cb) {
      let query = {
        text_search: "",
        project_home_search: queryString
      };

      if (this.isFilterTokenxUser) {
        query = {...query, is_filter_tokenx_user: true }
      }

      const response = await baanRueJaiClient.admin.users.search(query);
      const users = response.data.result.users;

      cb(
        users
          .map(user => toCamelCaseObject(user))
          .filter(user => user.homes && user.homes.length)
          .flatMap(item => {
            const user = item.user;
            const homes = item.homes;
            const name = `${user.userProfile.firstName} ${
              user.userProfile.lastName
            }`;

            return homes.map(h => {
              const home = `${h.addressNo} ${h.projectName}`;
              const role = h.userRole;
              const projectId = h.projectId;

              return {
                id: user.userId,
                homeId: h.homeId,
                projectId,
                name,
                home,
                role,
                data: { user: user, home: h }
              };
            });
          })
      );
    },
    handleSelect(item) {
      this.$emit("input", [...this.value, item]);
    },
    handleClickDeleteUser(userId, homeId) {
      this.users.forEach((val,index) => {
        if (userId === val.id && homeId === val.homeId) {
          this.users.splice(index, 1); 
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.user {
  padding: 6px 0;

  > .name {
    font-weight: bold;
  }

  > .name,
  > .home {
    line-height: 1.4;
  }

  > .home {
    color: #777;
    font-size: 12px;
    white-space: normal;
    word-break: break-word;
  }
}

.user-search-input {
  margin-bottom: 10px;
  width: 100%;
}

.btn-delete {
  width: 36px;
  height: 36px;
  border-radius: 36px;
  padding: 0;
}

.user-list-item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 8px 0;

  > .user {
    flex-grow: 1;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/managements/modules/messaging/components/UserList.vue